import * as types from "../actions/actionsTypes";
import initialState from "./initialState";

export default function experienceUserReducer(
  state = initialState.userExperience,
  action
) {
  if (action.type === types.LOADED_EXPERIENCE_DATA_SUCCESS) {
    return action?.userExperience;
  }
  return state;
}